import { getEWPDomain } from '../selectors/getBaseUrlSelectors';

export default {
  fetch: (locale, action, state) => ({
    url: `${getEWPDomain(state)}/travel/v1/tulips_rds/refcodes/SWFARLN?locale=${locale?.toLowerCase()?.replace('-', '_')}&context_cd=SWF&active=Y`,
  }),
  idKey: 'code',
  transformData: (data) => data
    ?.map((item) => {
      const descObject = JSON.parse(item.refcddesc);
      return {
        name: descObject.desc,
        code: item.refcd,
      };
    })
    ?.sort((firstAirline, secondAirline) => firstAirline.name.localeCompare(secondAirline.name)),
};
